'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import propsync from '../common/util/propsync'
//  const modal = weex.requireModule('modal');
exports.default = {
  name: 'dofPromt',
  // mixins: [propsync],
  props: {
    show: {
      type: Boolean
    },
    inputValue: {
      type: String
    },
    placeholder: {
      type: String
    },
    title: {
      type: String
    },
    cancelColor: {
      type: String,
      default: '#00A4F2'
    },
    confirmColor: {
      type: String,
      default: '#00A4F2'
    }
  },
  watch: {
    inputValue: function inputValue(val) {
      this.inputName = val;
    }
  },
  methods: {
    onInput: function onInput(event) {
      this.inputName = event.value;
      this.$emit('onPromtInput', event.value);
    },
    onOkClicked: function onOkClicked(event) {
      this.$emit('okClicked', event);
    },
    onCancled: function onCancled(event) {
      this.$emit('onPromtClose', event);
    }
  },
  computed: {
    /* isNeedShow () {
      return this.show;
    }*/
  },
  data: function data() {
    return {
      inputName: ''
    };
  },
  created: function created() {
    var env = weex.config.env;
    this.pageHeight = env.deviceHeight / env.deviceWidth * 750 - 150;
    this.maskHeight = env.deviceHeight / env.deviceWidth * 750;
    this.boxMarginTop = this.maskHeight / 4;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-promt/index.vue
// module id = 372
// module chunks = 0 1